<template>
  	<div class="bg-grey h-auto pt-8 pb-10">

		<div class="flex justify-center" v-for="(page, index) in pages" :key="page.id">
			<Sidebar class="mr-8" :page_id="page.id"></Sidebar>

			<page class="page" :page="page" :index="index" :class="page.paperType.slug"></page>
		</div>

		<CustomerModal></CustomerModal>
		<PageSettingsModal></PageSettingsModal>
		<TextModal></TextModal>
		<ImageModal></ImageModal>
		<PrintModal></PrintModal>
		<TemplateModal></TemplateModal>
		<InterpolationModal></InterpolationModal>
		<BackgroundMapModal></BackgroundMapModal>
		<AddExtraAnalysisModal></AddExtraAnalysisModal>

  	</div>
</template>

<script>

import {fabric} from 'fabric'
import axios from 'axios'

import Page 					from '@/components/Page.vue'
import Sidebar 					from '@/components/Sidebar.vue'
import CustomerModal 			from '@/components/customersampling/CustomerModal.vue'
import PageSettingsModal		from '@/components/modals/PageSettingsModal.vue'
import TextModal 				from '@/components/modals/TextModal.vue'
import ImageModal 				from '@/components/modals/ImageModal.vue'
import PrintModal 				from '@/components/modals/PrintModal.vue'
import TemplateModal 			from '@/components/modals/TemplateModal.vue'
import InterpolationModal 		from '@/components/modals/InterpolationTypeModal.vue'
import BackgroundMapModal 		from '@/components/modals/BackgroundMapModal.vue'
import AddExtraAnalysisModal 	from '@/components/modals/AddExtraAnalysisModal.vue'

import { mapGetters } from 'vuex'

export default {

	name: 'printLayout',

	components: {
		Page,
		Sidebar,
		CustomerModal,
		PageSettingsModal,
		TextModal,
		ImageModal,
		PrintModal,
		TemplateModal,
		InterpolationModal,
		BackgroundMapModal,
		AddExtraAnalysisModal
	},

	computed: {
		...mapGetters({
			pages:				'layout/pages',
			currentTemplate:	'template/defaultTemplate',
		}),
	},

	mounted() {
		this.$store.dispatch("interpolationSettings/GET_INTERPOLATION_SETTINGS")
		this.$store.dispatch('template/GET_TEMPLATES').then(() => {
			if(this.pages.length === 0) {
				this.addPage()
			}
		})
	},

	methods: {
		addPage() {
			if(this.currentTemplate) {
				this.$store.dispatch("layout/ADD_NEW_PAGE_FROM_TEMPLATE", JSON.parse(this.currentTemplate.json));
			} else {
				this.$store.dispatch("layout/ADD_NEW_PAGE");
			}
		},
	},

}
</script>

<style>
.page {
	background: white;
	display: block;
	margin-bottom: 0.5cm;
	box-shadow: 0 0 0.5cm rgba(0,0,0,0.5);
}

.a4-standing {
  	width: 21cm;
  	height: 29.7cm; 
}

.a4-landscape {
  width: 29.7cm;
  height: 21cm;  
}

.a3-standing {
  width: 29.7cm;
  height: 42cm;
}

.a3-landscape {
  width: 42cm;
  height: 29.7cm;  
}
</style>